export const permissionsList = {
  MANAGE_LEAVE_REQUESTS: 'manage_leave_requests',
  MANAGE_GOALS: 'manage_goals'
};
